import { render, staticRenderFns } from "./ToolArea.vue?vue&type=template&id=22fdf9b8&scoped=true&"
import script from "./ToolArea.vue?vue&type=script&lang=ts&"
export * from "./ToolArea.vue?vue&type=script&lang=ts&"
import style0 from "./ToolArea.vue?vue&type=style&index=0&id=22fdf9b8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdf9b8",
  null
  
)

export default component.exports